import { render, staticRenderFns } from "./addQuestionBank.vue?vue&type=template&id=6e9b53d8&scoped=true&"
import script from "./addQuestionBank.vue?vue&type=script&lang=js&"
export * from "./addQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionBank.vue?vue&type=style&index=0&id=6e9b53d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b53d8",
  null
  
)

export default component.exports